import roomSkeatLinks from '@/assets/extra/room_skeat_links.json';

// Only for link skeat
const SKEAT_BASE_URL = 'https://app.skeat.fr';
const SKEAT_GENERIC_ROOM_KEY = 'GENERIC';
const skeatLinkMap = roomSkeatLinks.reduce((accumulator, {room_number: roomNumber, link}) => {
    if (roomNumber && link) {
        accumulator[roomNumber] = link;
    }
    return accumulator;
}, {});

export const SectionRouter = {
    methods: {
        isSectionInSchedule(section) {
            if (section.navigation && section.navigation.type === 'unavailable') {
                return false;
            }

            return section.in_schedule !== false;
        },

        showSectionOutOfScheduleModal(section) {
            const text = (this.displayScheduleText && this.displayScheduleText(section))
                || this.$root.getKeyWord('available_soon');

            this.$modal.show('modal-display-working-hours', {
                title: '',
                text: text,
            });
        },

        resolveSectionNavigation(section) {
            if (section.navigation && section.navigation.type) {
                return section.navigation;
            }

            return this.resolveLegacySectionNavigation(section);
        },

        resolveLegacySectionNavigation(section) {
            if (!this.isSectionInSchedule(section)) {
                return { type: 'unavailable' };
            }

            if (section.tags && section.tags.some(tag => tag.ptag_id === 'booking')) {
                return {
                    type: 'restaurants',
                    path: '/restaurants',
                    query: { section_id: section.id },
                };
            }

            if (section.sublevels_count > 1) {
                return {
                    type: 'sections',
                    path: '/sections/' + section.id,
                };
            }

            const activeProductsCount = Number(section.active_products_count || 0);
            if (section.external_link && activeProductsCount === 0) {
                return {
                    type: 'external',
                    url: section.external_link,
                };
            }

            return {
                type: 'products',
                path: '/products/' + section.id,
            };
        },

        routeSectionLink(section) {
            const navigation = this.resolveSectionNavigation(section);

            if (navigation.type === 'unavailable') {
                this.showSectionOutOfScheduleModal(section);
                return false;
            }

            if (navigation.type === 'external') {
                const externalLink = this.resolveSectionExternalLink(navigation.url);
                window.open(externalLink, '_blank');
                return false;
            }

            if (navigation.type === 'sections') {
                this.$root.title = this.$root.getLangText(section.title);
                this.$router.push({
                    path: navigation.path,
                    props: {
                        parentSection: section,
                    },
                });
                return false;
            }

            if (navigation.type === 'restaurants') {
                this.$router.push({
                    path: navigation.path,
                    query: navigation.query || { section_id: section.id },
                });
                return false;
            }

            this.$root.title = section.title;
            this.$router.push({ path: navigation.path || ('/products/' + section.id) });
        },

        resolveSectionExternalLink(externalLink) {
            if (!externalLink || externalLink.indexOf(SKEAT_BASE_URL) === -1) {
                return externalLink;
            }

            let roomNumber = null;

            if (typeof window !== 'undefined' && window.localStorage) {
                try {
                    roomNumber = window.localStorage.getItem('fs_room_number');
                } catch (error) {
                    roomNumber = null;
                }
            }

            if (roomNumber) {
                const normalizedRoom = roomNumber.trim();
                if (normalizedRoom && skeatLinkMap[normalizedRoom]) {
                    return skeatLinkMap[normalizedRoom];
                }
            }

            if (skeatLinkMap[SKEAT_GENERIC_ROOM_KEY]) {
                return skeatLinkMap[SKEAT_GENERIC_ROOM_KEY];
            }

            return externalLink;
        }
    },
};
